import {MutableRefObject, useState} from 'react';
import useResizeObserver from '@react-hook/resize-observer';

const useIsOverflowing = (contentRef: MutableRefObject<HTMLElement | null>) => {
    const [containerWidth, setContainerWidth] = useState<number | undefined>(
        undefined,
    );
    const [isOverflowing, setIsOverflowing] = useState(false);

    // Where the magic happens
    useResizeObserver(contentRef, () => {
        if (contentRef.current) {
            setContainerWidth(contentRef.current.offsetWidth);
            setIsOverflowing(
                contentRef.current.scrollWidth > contentRef.current.offsetWidth,
            );
        }
    });

    return {
        containerWidth,
        isOverflowing,
    };
};

export default useIsOverflowing;
